export default __webpack_public_path__ + "static/media/Chrome.f93ac8a9.svg";